import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import ComputerDetail from "@/pages/ComputerDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminForm from "@/pages/AdminForm";
import Stats from "@/pages/Stats";

function AdminRoute({ children }) {
    const { user, ready } = useAuth();
    const location = useLocation();
    if (!ready) {
        return (
            <div className="py-32 text-center font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
                Authenticating<span className="terminal-caret" />
            </div>
        );
    }
    if (!user || user.role !== "admin") {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    return children;
}

function Shell() {
    return (
        <div className="min-h-screen flex flex-col grain">
            <Navbar />
            <main className="flex-1">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/computer/:id" element={<ComputerDetail />} />
                    <Route path="/stats" element={<Stats />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route
                        path="/admin"
                        element={
                            <AdminRoute>
                                <AdminDashboard />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/admin/new"
                        element={
                            <AdminRoute>
                                <AdminForm />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/admin/:id/edit"
                        element={
                            <AdminRoute>
                                <AdminForm />
                            </AdminRoute>
                        }
                    />
                </Routes>
            </main>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Shell />
                    <Toaster
                        theme="dark"
                        position="bottom-right"
                        toastOptions={{
                            style: {
                                background: "#09090B",
                                color: "#EDEDED",
                                border: "1px solid #27272A",
                                borderRadius: 0,
                                fontFamily: "JetBrains Mono, monospace",
                                fontSize: 12,
                            },
                        }}
                    />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
